import { Typography } from "@circle-react-uikit/Typography";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface ActionButtonProps extends ComponentPropsWithoutRef<typeof Button> {
  children: ReactNode;
  compressedCTA?: boolean;
  iconEl?: ReactNode;
}

export function ActionButton({
  children,
  iconEl,
  className,
  compressedCTA = false,
  ...rest
}: ActionButtonProps) {
  const TypographyComponent = compressedCTA
    ? Typography.LabelXs
    : Typography.LabelMd;

  return (
    <Button
      variant="secondary"
      className={classNames("mx-auto w-max", className)}
      large
      {...rest}
    >
      <div
        className={classNames(
          "text-darkest flex gap-x-2",
          compressedCTA && "min-w-[156px] justify-center px-3 py-2.5",
        )}
      >
        {iconEl}
        <TypographyComponent weight="semibold" color="text-darkest">
          {children}
        </TypographyComponent>
      </div>
    </Button>
  );
}
